import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const TabContent = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 20px;
`

export const Content = styled('div')`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    padding: 0px;
`

export const NotesContent = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    color: var(--color-greys-0);
`

export const SourceUrl = styled('a')`
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: blue;
    text-decoration: underline;
`

export const SourceUrlContainer = styled('div')`
    max-width: 150px;
    display: flex;
`

export const NoInputText = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme.colors.greys[400]};
`

export const Flex = styled('div')`
    display: flex;
    align-content: center;
    align-items: center;
    gap: 8px;
`
